import jQuery from 'jquery'; // Import jQuery directly as jQuery
window.jQuery = jQuery;
window.$ = jQuery; // Assign to both jQuery and $ globals

import "intersection-observer";

// missing forEach on NodeList for IE11
if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}



// --- ADD THESE LINES FOR BOOTSTRAP 4 ---
import 'jquery'; // Bootstrap 4 depends on jQuery
import 'popper.js'; // Bootstrap 4 depends on Popper.js
import 'bootstrap/dist/js/bootstrap.min.js';

// *** THEN IMPORT EVOKE ***
import './evoke/evoke-v3-bundle.min.js'; // Adjust path if necessary
import './evoke/screenshots.js'; // Adjust path if necessary
// *************************

import isiJS from "./isi";
import navToggleJS from "./navToggle";
import stickyNavJS from "./stickyNav";
import collapseJS from "./collapse";
import modalJS from "./modal";
import formJS from "./form";
import textGradientJS from "./textGradient";
import resourcesScrollJS from "./resourcesScroll.js";
import videoJS from "./video.js";
import scrollDrawerJS from "./scrollDrawer.js";
import "./cache.js";

// import defendher from "./defendher.js";
import scrolling from "./scrolling.js";




const callback = function () {
	navToggleJS();
	stickyNavJS();
	isiJS();
	collapseJS();
	modalJS();
	formJS();
	textGradientJS();
	resourcesScrollJS();
	videoJS();
	scrollDrawerJS();
	// defendher();
	scrolling();
};

if (document.readyState === "complete" || (document.readyState !== "loading" && !document.documentElement.doScroll)) {
	// console.log('dom not loaded yet')
	callback();
} else {
	document.addEventListener("DOMContentLoaded", callback);
	// console.log('dom loaded')
}
// Optional: If you want to link the tab and accordion states
        // When a tab is shown, close all accordion items and show the corresponding one
        $('#myTab a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            var targetId = $(e.target).attr('href'); // e.g., #tab1
            var accordionTargetId = '#collapse' + targetId.replace('#tab', ''); // e.g., #collapse1

            // Hide all accordion collapses
            $('#myAccordion .collapse').collapse('hide');
            // Show the corresponding accordion collapse
            $(accordionTargetId).collapse('show');
        });

        // When an accordion item is shown, activate the corresponding tab
        $('#myAccordion .collapse').on('shown.bs.collapse', function () {
            var accordionId = $(this).attr('id'); // e.g., collapseOne
            var tabId = '#tab' + accordionId.replace('collapse', ''); // e.g., #tab1

            // Deactivate all tabs
            $('#myTab a').removeClass('active');
            // Activate the corresponding tab
            $(tabId + '-tab').tab('show');
        });


document.addEventListener('DOMContentLoaded', function() {
  // Get the current URL path
  const path = window.location.pathname;

  // Define what your homepage path(s) might be
  // Common homepage paths: '/', '/index.html', '/home'
  // You might need to adjust this based on your site's specific setup.
  const isHomepage = (path === '/');

  const violatorSection = document.querySelector('.acr-violator-section');

  if (violatorSection) { // Check if the element exists on the page
    if (isHomepage) {
      violatorSection.style.display = 'block'; // Or 'flex', 'grid', etc., based on its original display type
    } else {
      // If it's not the homepage, ensure it's hidden (redundant if CSS handles it, but good for robustness)
      violatorSection.style.display = 'none';
    }
  }
});
